import React, { lazy, Suspense, useEffect, useContext } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { ThemeProvider } from '@carvana/theme';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withDocumentTitle, ErrorBoundary } from '@carvana/purchase-helpers';
import { Loading } from '@carvana/purchase-styles';
import { LoadOrderPlaced } from './ducks/actions';
import { init } from './ducks/combineReducer';
import { getOrderPlacedHasLoaded } from './ducks/selectors';
import {
  CancelOrderModal,
  EditOrderModal
} from './components/order-placed/components/modals';

const OrderPlacedRoot = lazy(() =>
  import(
    /* webpackChunkName: "identity-root", webpackPrefetch: true */ './components/order-placed'
  )
);

const CustomerRequest = lazy(() =>
  import(
    /* webpackChunkName: "identity-root", webpackPrefetch: true */ './components/customer-request'
  )
);

const InsuranceQuote = lazy(() =>
  import(
    /* webpackChunkName: "identity-root", webpackPrefetch: true */ './components/insurance-quote'
  )
);

const Routes = props => {
  const {
    match: { path },
    hasLoaded,
    registry,
    ...rest
  } = props;

  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    init(registry);
    LoadOrderPlaced();
    trackEvent('RetrievedCustomerRequest');
  }, []);

  if (!hasLoaded) return <Loading />;

  return (
    <Suspense fallback={<Loading />}>
      <ErrorBoundary>
        <ThemeProvider>
          <Route
            exact
            path={path}
            render={() => <OrderPlacedRoot {...rest} />}
          />
          <Route
            exact
            path={`${path}/customer-request`}
            render={() => <CustomerRequest {...rest} />}
          />
          <Route
            path={`${path}/customer-request/insurance-quote`}
            render={() => <InsuranceQuote padding {...rest} />}
          />
        </ThemeProvider>
      </ErrorBoundary>
    </Suspense>
  );
};

Routes.propTypes = {
  match: PropTypes.shape({}).isRequired,
  hasLoaded: PropTypes.bool,
  registry: PropTypes.shape({})
};

Routes.defaultProps = {
  registry: null,
  hasLoaded: false
};

const mapStateToProps = state => ({
  hasLoaded: getOrderPlacedHasLoaded(state)
});

export default compose(
  withDocumentTitle('Order Placed'),
  withRouter,
  connect(mapStateToProps)
)(Routes);

export { CancelOrderModal, EditOrderModal };
